import { OptionsWithoutBackground } from "src/routes/onboarding/shared/components/optionsWithoutBackground";
import background from "./bg.png";

const data = [
  {
    value: "EVERY_DAY",
    displayValue: "Almost every day",
  },
  {
    value: "THREE_FOUR_TIMES_A_WEEK",
    displayValue: "3-4 times per week",
  },
  {
    value: "ONE_TWO_TIMES_A_WEEK",
    displayValue: "1-2 times per week",
  },
    {
    value: "ONCE_A_MONTH",
    displayValue: "Once a month",
  }
];

export const HowOftenWalks = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    onNextStep?.(v.value);
    onTrackEvent?.(v.value);
    localStorage.setItem("howOftenWalks", v.value); // ?
  };
  return (
    <OptionsWithoutBackground
      isWalky={true}
      data={data}
      title="How often do you go for walks?"
      onClick={handleNextStep}
      background={background}
    />
  );
};
